import { ChannelsSet, Pagination } from '@app/core/models';
import { ManageSetsTableFilters } from '@app/shared/filters/models/manage-sets-table';
import { createAction, props } from '@ngrx/store';
import { SortDirection } from '@rds/angular-components';

export const initTable = createAction(
  '[CHANNELS SETS - TABLE] Initialize Channels'
);

export const clearAll = createAction(
  '[CHANNELS SETS - TABLE] Clear all'
);

export const getTableRequest = createAction(
  '[CHANNELS SETS - TABLE] Get channels Request',
  props<{
    pageIndex: number,
    pageSize: number,
    sort: {
      active: string;
      direction: SortDirection
    },
    filters: {[key: string]: any},
  }>()
);

export const getTableSuccess = createAction(
  '[CHANNELS SETS - TABLE] Get channels Success',
  props<{ data: Array<ChannelsSet>, pagination: Pagination }>()
);

export const getTableFailure = createAction(
  '[CHANNELS SETS - TABLE] Get channels Failure',
  props<{ error: any }>()
);

export const changeTableFilters = createAction(
  '[CHANNELS SETS - TABLE] Change channels filters',
  props<{ filters: ManageSetsTableFilters }>()
);

export const changeTableSort = createAction(
  '[CHANNELS SETS - TABLE] Change channels sort',
  props<{ active: string, direction: SortDirection }>()
);

export const changeTablePagination = createAction(
  '[CHANNELS SETS - TABLE] Change channels pagination',
  props<{ pageIndex: number, pageSize: number }>()
);

export const deleteChannelsSetRequest = createAction(
  '[CHANNELS SETS - TABLE] Delete User role Request',
  props<{id: number}>()
);

export const deleteChannelsSetSuccess = createAction(
  '[CHANNELS SETS - TABLE] Delete channels Success',
);

export const deleteChannelsSetFailure = createAction(
  '[CHANNELS SETS - TABLE] Delete channels Failure',
  props<{ error: any }>()
);
